export function mapInspectionKindRow(row) {
  return {
    id: row?.id ?? '',
    code: row?.code ?? '',
    name: row?.name ?? '',
    status: row?.status ?? '',
    sequence: row?.sequence ?? null,
  };
}

export function sortInspectionKinds(rows) {
  return [...(rows ?? [])].sort((left, right) => {
    const leftSequence = Number(left?.sequence ?? Number.MAX_SAFE_INTEGER);
    const rightSequence = Number(right?.sequence ?? Number.MAX_SAFE_INTEGER);
    if (leftSequence !== rightSequence) {
      return leftSequence - rightSequence;
    }
    const byCode = String(left?.code ?? '').localeCompare(String(right?.code ?? ''));
    if (byCode !== 0) {
      return byCode;
    }
    return String(left?.id ?? '').localeCompare(String(right?.id ?? ''));
  });
}

export function buildInspectionKindsPayload(rows, updatedAt) {
  const seen = new Set();
  const inspectionKindIds = [];

  (rows ?? []).forEach((row) => {
    const id = String(row?.id ?? '').trim();
    if (!id || seen.has(id)) {
      return;
    }
    seen.add(id);
    inspectionKindIds.push(id);
  });

  return {
    inspectionKindIds,
    updatedAt: updatedAt ?? null,
  };
}

/**
 * 保留既有順序，只把新勾選的啟用種類加在後面。
 * 已從畫面移除的停用種類（blockedIds）不會再加回。
 */
export function mergeInspectionKindSelection(currentRows, selectedIds, candidates, blockedIds) {
  const selected = selectedIds instanceof Set ? selectedIds : new Set(selectedIds);
  const blocked = blockedIds instanceof Set ? blockedIds : new Set();
  const kept = [];
  const keptIds = new Set();

  (currentRows ?? []).forEach((row) => {
    const id = String(row?.id ?? '');
    if (!id || !selected.has(id) || blocked.has(id)) {
      return;
    }
    kept.push(row);
    keptIds.add(id);
  });

  const added = [];
  (candidates ?? []).forEach((row) => {
    const id = String(row?.id ?? '');
    if (!id || !selected.has(id) || keptIds.has(id) || blocked.has(id)) {
      return;
    }
    if (row.status !== 'ACTIVE') {
      return;
    }
    added.push(mapInspectionKindRow(row));
  });

  return [...kept, ...added];
}
